var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("fiscal-years-select", {
        attrs: { fiscalYears: _vm.settings.fiscalyears },
        on: {
          updateFiscalYears: _vm.updateFiscalYears,
          loaded: function($event) {
            return _vm.$emit("updateLoading", { loading: false })
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "mb-4",
          attrs: {
            label: _vm.$t.__(
              "dashboard.forms.PurInvoiceSettingForm.select_display_total_invoice_amount_or_total_outstanding_amount"
            ),
            prop: "displayAmount"
          }
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.displayAmount,
                callback: function($$v) {
                  _vm.$set(_vm.form, "displayAmount", $$v)
                },
                expression: "form.displayAmount"
              }
            },
            [
              _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c("el-radio", { attrs: { label: "total" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Total de la facture")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-radio",
                    { staticClass: "mt-3", attrs: { label: "due" } },
                    [_vm._v(_vm._s(_vm.$l10n.__("Total restant dû (TTC)")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.displayAmount == "total"
        ? [
            _c(
              "el-form-item",
              {
                staticClass: "mb-4",
                attrs: {
                  label: _vm.$t.__("common.actions.select_tax_display"),
                  prop: "taxMode"
                }
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.form.taxMode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "taxMode", $$v)
                      },
                      expression: "form.taxMode"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c("el-radio", { attrs: { label: "exc" } }, [
                          _vm._v(_vm._s(_vm.$l10n.__("HT")))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-radio",
                          { staticClass: "mt-3", attrs: { label: "inc" } },
                          [_vm._v(_vm._s(_vm.$l10n.__("TTC")))]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aright mt-5" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submitForm }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }